import { BACKGROUND_TEXT_MODE } from '../../../constants';
import type { TextElementToDisplay } from './types';

function hasHighlightTextBox(element: TextElementToDisplay) {
  return element.backgroundTextMode === BACKGROUND_TEXT_MODE.HIGHLIGHT;
}

export function getTextContentWidth({
  element,
  dataToEditorX,
  width,
}: {
  element: TextElementToDisplay;
  dataToEditorX: (value: number) => number;
  width: number;
}) {
  const horizontalPadding = dataToEditorX(element.padding?.horizontal || 0);

  return Math.max(0, width - horizontalPadding * 2);
}

export function getTextBoxVerticalPadding({
  element,
  dataToEditorY,
}: {
  element: TextElementToDisplay;
  dataToEditorY: (value: number) => number;
}) {
  return dataToEditorY(element.padding?.vertical || 0);
}

export function getHighlightLinePadding({
  element,
  dataToEditorX,
}: {
  element: TextElementToDisplay;
  dataToEditorX: (value: number) => number;
}) {
  if (!hasHighlightTextBox(element)) {
    return 0;
  }

  return dataToEditorX(element.padding?.vertical || 0);
}
